import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import tradeDataStore from "@/store/tradeDataStore";
import { useTheme } from "next-themes";
import { findCPOnTradeByBlockId } from "../../tradeLookupHelpers";
import { formatDeliveryDate } from "./deliveryDateFormatter";
import { isDeliveryDateEditable } from "./deliveryDateHelpers";

/**
 * DeliveryDateCellRenderer
 *
 * Displays delivery date with real-time Zustand updates for editability styling.
 * Replaces the cellClass callback approach which required redrawRows()/refreshCells()
 * to re-evaluate, so status changes (e.g. to Affirmed) only styled the cell after a refresh.
 */
const DeliveryDateCellRenderer = (params: any) => {
  const { theme } = useTheme();
  const { fullTradeData } = returnAllTradeDetailsFromGenericParams(params);

  const currentTradeData = tradeDataStore((state) => state.tradeData);
  const thisTrade =
    currentTradeData.find((trade) => trade.esid == fullTradeData.esid) ??
    fullTradeData;

  const thisER = findCPOnTradeByBlockId(thisTrade, params.data?.blockId);
  const thisLeg = thisER?.legs?.find(
    (leg: any) => leg.blockId == params.data?.blockId,
  );

  const liveStatusER = thisLeg?.statusER ?? params.data?.statusER;
  const liveSecurityType = thisLeg?.securityType ?? params.data?.securityType;

  const editable = isDeliveryDateEditable(liveStatusER, liveSecurityType);

  function editableStyle() {
    if (editable && theme == "light") {
      return "inputCellOtherLight roundedInputCell";
    } else if (editable && theme == "dark") {
      return "inputCellOtherDark roundedInputCell";
    }
    return "roundedInputCell";
  }

  return (
    <div
      data-testid="DeliveryDateCellContainer"
      id="DeliveryDateCellContainer"
      className={editableStyle()}
    >
      {formatDeliveryDate(params.value)}
    </div>
  );
};

export default DeliveryDateCellRenderer;
